import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import $ from 'jquery';
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { AddCampusResourse } from "../../../../services/CampusPagesServer";
import { IMAGE_URL } from "../../../../utils/Constants";
import { mapBuildingsToApi, mapBuildingsToSelect } from "../../../../utils/CampusBuildingsUtil";
import CampusBuildingMultiSelect from "../../../common/CampusBuildingMultiSelect";

const CreateResourses = ({
    campusId,
    resourceFormik,
    resourceType,
    setSelectedData,
    row,
    id,
}) => {
    const [iconName, setIconName] = useState("");
    const [data, setData] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: data.id || "",
            resourceName: data.resourceName || "",
            uploadResource: data.uploadResource || "",
            buildings: mapBuildingsToSelect(row?.buildings)
        },
        validationSchema: Yup.object({
            resourceName: Yup.string().required("Resource Name is required"),
        }),
        onSubmit: async (values, actions) => {
            if (isSubmitting) return;
            setIsSubmitting(true);
            
            try {
                const formData = new FormData();
                formData.append("id", values.id);
                formData.append("resourceName", values.resourceName);
                formData.append("uploadResource", values.uploadResource);
                formData.append("campusId", campusId);
                formData.append(
                    "buildings",
                    JSON.stringify((values.buildings || []).map(b => b.value))
                );
                
                const res = await AddCampusResourse(formData);
                const message = row ? "Updated Successfully" : "Added Successfully";

                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: message,
                });

                if (row) {
                    const filteredData = resourceFormik.values.resource_id?.map((item) => {
                        if (item.id == formik.values.id) {
                            return { ...item, buildings: mapBuildingsToApi(values.buildings) };
                        }
                        return item;
                    });
                    resourceFormik.setFieldValue("resource_id", filteredData);
                } else {
                    const newResource = {
                        ...res?.data?.getData,
                        buildings: mapBuildingsToApi(values.buildings)
                    };
                    resourceFormik.setFieldValue("resource_id", [
                        ...(resourceFormik.values.resource_id || []),
                        newResource
                    ]);
                }
                $(`#${id}`).modal('hide');
                actions.resetForm();
                setIconName('');
            } catch (error) {
                console.error("Error saving resource:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error.response?.data?.message || "Failed to save resource. Please try again.",
                });
            } finally {
                setIsSubmitting(false);
            }
        }
    });

    useEffect(() => {
        const modalElement = $(`#${id}`);
        const handleModalClose = () => {
            formik.resetForm();
            setSelectedData({});
            setIconName('');
            setIsSubmitting(false);
        };
        modalElement.on('hidden.bs.modal', handleModalClose);
        return () => {
            modalElement.off('hidden.bs.modal', handleModalClose);
        };
    }, [formik, id, setSelectedData]);

    usePermissionGuardRedirect(['pmcmedit']);

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (file) {
            formik.setFieldValue("uploadResource", file);
            setIconName(file.name);
        }
        e.target.value = null;
    };

    useEffect(() => {
        if (row) {
            setData(row);
            setIconName(
                typeof row?.uploadResource === 'string'
                    ? row.uploadResource.split('/').pop()
                    : (typeof row?.uploadResource === 'object' ? row.uploadResource?.name : "")
            );
            const selectedBuildings = mapBuildingsToSelect(row?.buildings);
            formik.setFieldValue("buildings", selectedBuildings);
        }
    }, [row]);
    
    return (
        <div className="card card-profile-info-card border-0">
            <div className="card-body-inr card-body-info">
                <div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group-blk mb-3">
                                <label>Resource Name *</label>
                                <input
                                    type="text"
                                    className={
                                        "form-control" +
                                        (formik.errors.resourceName && formik.touched.resourceName
                                            ? " is-invalid"
                                            : "")
                                    }
                                    placeholder="Enter Resource Name"
                                    name="resourceName"
                                    id="resourceName"
                                    title="Resource Name"
                                    value={formik.values.resourceName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group-blk mb-3">
                                <label>Upload Resource <i className="fal fa-info-circle"></i></label>
                                <div className="d-flex align-items-center">
                                    <span className="mr-2">Upload</span>
                                    <div className="form-group atttach-file mb-0">
                                        <label
                                            className={
                                                formik.errors.uploadResource && formik.touched.uploadResource && "file-req is-invalid"
                                            }
                                        >
                                            <i className="fal fa-upload"></i>
                                            <span>Browse</span>
                                            <input
                                                type="file"
                                                className="form-control form-control-aatch-file"
                                                onChange={handleFileChange}
                                                name="uploadResource"
                                                id="uploadResource"
                                                accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
                                                disabled={isSubmitting}
                                            />
                                        </label>
                                    </div>
                                </div>
                                {iconName && (
                                    <div className="frm-group d-flex align-items-center mt-2">
                                        <ul className="list-unstyled attached-file-ul m-0">
                                            <li>
                                                <a href={IMAGE_URL + encodeURI(formik.values.uploadResource)} target="_blank" style={{ maxWidth: '250px' }}>
                                                    <i className="fal fa-file"></i>
                                                    &nbsp;{iconName}
                                                </a>
                                            </li>
                                        </ul>
                                        <button
                                            type="button"
                                            className="btn btn-danger rounded-circle ml-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                formik.setFieldValue("uploadResource", "");
                                                setIconName("");
                                            }}
                                            disabled={isSubmitting}
                                        >
                                            <i className="fal fa-trash-alt"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <CampusBuildingMultiSelect
                            campusId={resourceFormik.values.linkedCampus || campusId}
                            value={formik.values.buildings}
                            onChange={(value) => formik.setFieldValue("buildings", value)}
                            required={false}
                            col_md={12}
                            col_lg={12}
                        />
                    </div>

                    <div className="form-group form-group-save-cancel mt-4">
                        <button
                            className="btn btn-save btn-success"
                            type="button"
                            onClick={formik.handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? <i className="fas fa-spinner fa-spin"></i> : <i className="fal fa-save"></i>}
                            Save
                        </button>

                        <button 
                            className="btn btn-close btn-danger" 
                            type="button" 
                            data-dismiss="modal" 
                            title="Close"
                            disabled={isSubmitting}
                        >
                            <i className="fal fa-times"></i>
                            Cancel
                        </button>
                    </div>
                    {Object.keys(formik.errors).map((key) => {
                        if (formik.touched[key]) {
                            return (
                                <div className="invalid-feedback d-block" key={key}>
                                    {formik.errors[key]}
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default CreateResourses;